module.exports = __webpack_public_path__ + "media/images/number_19-e7c90efdf131c5f74d65d53e9c1ec40e.png";